import { logger } from '@/services/logger';

export const getDurationFromArrayBuffer = async (arrayBuffer: ArrayBuffer) => {
    const clonedArrayBuffer = arrayBuffer.slice(0);

    const audioContext = new AudioContext();

    try {
        const audioBuffer = await audioContext.decodeAudioData(clonedArrayBuffer);
        const duration = audioBuffer.duration;
        return duration;
    } catch (error) {
        logger.error('Error decoding audio data:', error);
        return 0;
    } finally {
        audioContext.close();
    }
};
